import React from 'react'
import { styled } from '@mui/material/styles'
import { Typography } from '@mui/material'
import { SidebarItemsType } from '../../types/sidebar'
import SidebarNavList from './SidebarNavList'

const Title = styled(Typography)(
  ({ theme }) => `
  color: ${theme.sidebar?.color || 'inherit'};
  font-size: ${theme.typography?.caption?.fontSize || 'inherit'};
  padding: ${theme.spacing(4)} ${theme.spacing(7)} ${theme.spacing(1)};
  opacity: 0.4;
  text-transform: uppercase;
  display: block;
`
)

type SidebarNavSectionProps = {
  component?: React.ElementType
  pages: SidebarItemsType[]
  title?: string
}

const SidebarNavSection: React.FC<SidebarNavSectionProps> = (props) => {
  const { title, pages, component: Component = 'nav', ...rest } = props

  return (
    <Component {...rest}>
      {title && <Title variant="subtitle2">{title}</Title>}
      <SidebarNavList pages={pages} depth={0} />
    </Component>
  )
}

export default SidebarNavSection
